import type { WizardComponentsMap } from '@lemonade-hq/chat-wizard-client-base';
import type { UniclientComponent } from '@lemonade-hq/uniclient-chat';
import { useEffect, useRef } from 'react';

interface UsePreloadWizardComponentsProps {
  readonly shouldPreload: boolean;
  readonly componentMap: WizardComponentsMap<UniclientComponent<string>['type']>;
}

export const usePreloadWizardComponents = ({ shouldPreload, componentMap }: UsePreloadWizardComponentsProps): void => {
  const didLoadComponents = useRef(false);

  useEffect(() => {
    const loadComponents = async (): Promise<void> => {
      didLoadComponents.current = true;
      const promises = Object.values(componentMap).map(async component => await component());
      await Promise.all(promises);
    };

    let timeout: NodeJS.Timeout;
    if (shouldPreload && !didLoadComponents.current) {
      // delaying load, allowing first step components to fetch their assets if needed first
      timeout = setTimeout(() => void loadComponents(), 500);
    }

    return (): void => clearTimeout(timeout);
  }, [shouldPreload, componentMap]);
};
